import { render, staticRenderFns } from "./ListInbox.vue?vue&type=template&id=2ecd033c"
import script from "./ListInbox.vue?vue&type=script&lang=js"
export * from "./ListInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd033c')) {
      api.createRecord('2ecd033c', component.options)
    } else {
      api.reload('2ecd033c', component.options)
    }
    module.hot.accept("./ListInbox.vue?vue&type=template&id=2ecd033c", function () {
      api.rerender('2ecd033c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/ListInbox.vue"
export default component.exports